import { isset, sameId } from "@cawita/core-front";
import { Affinity, AffinityProfile, AffinityStatus, Profile } from "../../../../frontend-shared/src/lib/models";

export function getDataNotFor(affinity: Affinity, relative: Profile): AffinityProfile { return affinity?.profiles?.find(p => !sameId(p.profile, relative)); }
export function getDataFor(affinity: Affinity, relative: Profile): AffinityProfile { return affinity?.profiles?.find(p => sameId(p.profile, relative)); }


export function getProfileToViewAs(affinity: Affinity, asProfile: Profile): Profile {
    if (!isset(affinity) || !isset(asProfile)) return null;
    const otherProfile = getDataNotFor(affinity, asProfile);
    return otherProfile?.profile;
}

export function isAffinityFlashedBy(affinity: Affinity, profile: Profile): boolean {
    if (!isset(affinity) || !isset(profile)) return false;
    const forProfile = getDataFor(affinity, profile);
    return isset(forProfile?.flashDate);
}

export function isAffinityBlockedBy(affinity: Affinity, profile: Profile): boolean {
    if (!isset(affinity) || !isset(profile)) return false;
    const forProfile = getDataNotFor(affinity, profile);
    return profile?.blockedProfiles?.some(p => sameId(p, forProfile.profile)) ?? false;
}

export function getAffinityStatusToViewAs(affinity: Affinity, profile: Profile): AffinityStatus {
    if (!isset(affinity) || !isset(profile)) return AffinityStatus.Default;
    const theirProfile = getDataNotFor(affinity, profile);
    const myProfile = getDataFor(affinity, profile);

    if (!!profile?.blockedProfiles?.some(p => sameId(p, theirProfile.profile))) return AffinityStatus.Blocked;
    if (affinity.isKatch) return AffinityStatus.Katched;
    if (isset(theirProfile) && !!theirProfile.flashDate) return AffinityStatus.FlashedMe;
    if (isset(myProfile) && !!myProfile.flashDate) return AffinityStatus.FlashedThem;
    return AffinityStatus.Default;
}